export const colorIndexesByPalleteMonetary = {
  green: [12, 7, 16, 14, 28, 17, 15],
  blue: [5, 0, 34, 15, 18, 6, 14],
  red: [5, 0, 13, 34, 8, 17, 15],
  blueGreen: [0, 5, 6, 28, 24, 17, 15],
  blueRed: [34, 1, 0, 10, 11, 17, 15],
  blueYellow: [9, 29, 0, 34, 13, 17, 15],
};

export const colorIndexesByPalleteMonetaryRatio = {
  green: [12, 7, 16, 14, 28, 17, 15],
  blue: [5, 0, 34, 15, 18, 6, 14],
  red: [5, 0, 13, 34, 8, 17, 15],
  blueGreen: [0, 5, 6, 28, 24, 17, 15],
  blueRed: [34, 1, 0, 10, 11, 17, 15],
  blueYellow: [9, 29, 0, 34, 13, 17, 15],
};

export const colorIndexesByPalletePhysical = {
  green: [12, 7, 16, 14, 28, 17, 15],
  blue: [5, 0, 34, 15, 18, 6, 14],
  red: [5, 0, 13, 34, 8, 17, 15],
  blueGreen: [0, 5, 6, 28, 24, 17, 15],
  blueRed: [34, 1, 0, 10, 11, 17, 15],
  blueYellow: [9, 29, 0, 34, 13, 17, 15],
};
